//import amplitude from 'amplitude-js'

/**
 * Analytics class unites two services for tracking user events: braze & amplitude.
 * Since it's a common task to send the same event to both services, the class
 * was created and behaves as a wrapper to be consistent and follow DRY.
 */
class Analytics {
  constructor() {
    this.appboy    = null
    this.amplitude = null
    this.userId    = null
    this.deviceID  = null

    // Only if api keys is set we initialize braze & amplitude.
    // In order to disable any of the services just
    // keep api keys empty in the .env file
    if (process.env.VUE_APP_BRAZE_API_KEY) {
      this.initAppboy()
    }

    if (process.env.VUE_APP_AMPLITUDE_API_KEY) {
      //this.initAmplitude()
    }
  }

  /**
   * Init braze.
   *
   * Note: Appboy is just its sdk name.
   */
  initAppboy() {
    this.appboy = require('appboy-web-sdk')

    this.appboy.initialize(process.env.VUE_APP_BRAZE_API_KEY, {
      baseUrl: 'https://customer.iad-03.braze.com/api/v3',
      enableLogging: false,
      minimumIntervalBetweenTriggerActionsInSeconds: 0,
      enableHtmlInAppMessages: true
    })

    this.appboy.display.automaticallyShowNewInAppMessages()
    this.appboy.openSession()
  }

  /**
   * Init amplitude.
   */
  initAmplitude() {
    /*
    this.amplitude = amplitude.getInstance()
    this.amplitude.init(process.env.VUE_APP_AMPLITUDE_API_KEY, null, {
      logLevel: 'INFO'
    })
    */
  }

  /**
   * Set braze & amplitude events device id.
   *
   * Unique id that allows client identification.
   *
   * @param id
   */
  setDeviceId(id) {
    //('setDeviceId: ', id)
    this.deviceID = id
  }


  /**
   * Set braze & amplitude users.
   *
   * It's important to keep id uppercase, this is a convention.
   *
   * @param id
   */
  setUserId(id) {
    //console.log('setUserId: ', id)
    this.userId = id.toUpperCase()

    if (this.appboy) {
      this.appboy.changeUser(this.userId)

      this.appboy.getUser().setCustomUserAttribute('VisitedWebVersion', true)
    }

    if (this.amplitude) {
      /*
      this.amplitude.setUserId(this.userId)

      let identify = new amplitude.Identify().set('VisitedWebVersion', true)
      amplitude.getInstance().identify(identify)
      */
    }
  }

  /**
   * Set user name.
   *
   * Braze has its own method, while amplitude uses custom attributes.
   *
   * @param name
   */
  setUserName(name) {
    if (this.appboy) {
      this.appboy.getUser().setFirstName(name)
    }

    if (this.amplitude) {
      /*
      let identify = new this.amplitude.Identify().set('name', name)
      this.amplitude.identify(identify)
      */
    }
  }

  /**
   * Set any kind of user custom attribute.
   *
   * @param name
   * @param value
   */
  setUserCustomAttribute(name, value) {
    if (this.appboy) {
      this.appboy.getUser().setCustomUserAttribute(name, value)
    }

    if (this.amplitude) {
      /*
      let identify = new this.amplitude.Identify().set(name, value)
      this.amplitude.identify(identify)
      */
    }
  }

  /**
   * Send event.
   *
   * Similar approach both for braze & amplitude.
   *
   * @param eventName
   * @param eventData
   */
  sendEvent(eventName, eventData = {}) {
    //console.log('Sending event...')
    //console.log('this.userId is: ', this.userId)
    // Todo: refactor
    // For some reason extracting event data to a separate
    // variable causes strange behaviour when debugging
    // with console.log(extractedDataVariable)

    if (this.appboy) {
      const brazeData = {
        ...eventData,
        EventSource: 'web',
        DeviceID: this.deviceID
      }

      //console.log('Sending event to braze', brazeData)
      this.appboy.logCustomEvent(eventName, brazeData)
    }

    if (this.amplitude) {
      /*
      const amplitudeData = {
        ...eventData,
        EventSource: 'web',
        DeviceID: this.deviceID
      }

      //console.log('Sending event to amplitude', amplitudeData)
      this.amplitude.logEvent(eventName, amplitudeData)
      */
    }
  }
}

export default new Analytics()
